import type { SVGProps } from "react";

export function GarageIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M11.5148 3.67812L4.76477 9.40539C4.59682 9.54789 4.5 9.75702 4.5 9.97727V19.25C4.5 19.388 4.61193 19.5 4.75 19.5H7V14.25C7 13.2835 7.7835 12.5 8.75 12.5H15.25C16.2165 12.5 17 13.2835 17 14.25V19.5H19.25C19.3881 19.5 19.5 19.388 19.5 19.25V9.97727C19.5 9.75702 19.4032 9.54789 19.2352 9.40539L12.4852 3.67812C12.2053 3.44063 11.7947 3.44063 11.5148 3.67812ZM8.5 17.5V19.5H15.5V17.5H8.5ZM15.5 16V14.25C15.5 14.1119 15.3881 14 15.25 14H8.75C8.61193 14 8.5 14.1119 8.5 14.25V16H15.5ZM4.75 21C3.7835 21 3 20.2165 3 19.25V9.97727C3 9.3165 3.29046 8.68913 3.7943 8.26163L10.5443 2.53435C11.384 1.82188 12.616 1.82188 13.4557 2.53435L20.2057 8.26163C20.7095 8.68913 21 9.3165 21 9.97727V19.25C21 20.2165 20.2165 21 19.25 21H4.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
